/**
 * @deprecated This utility is to be deprecated. Use decimal-utils.js for all number operations.
 * These functions are kept for backward compatibility but should not be used in new code
 * as they may have floating-point precision issues.
 * 
 * @module deprecated/number-formatter
 */

/**
 * @deprecated Use decimal-utils.toDecimal() instead
 * @param {*} val - The value to convert to a number
 * @returns {number} The converted number, or 0 if invalid
 */
export const toNumber = (val) => {
  console.warn('toNumber() is deprecated. Use decimal-utils.toDecimal() instead.');
  const n = Number(val);
  return isNaN(n) ? 0 : n;
};

/**
 * @deprecated Use decimal-utils.roundValue() instead
 * @param {number} val - The value to round
 * @returns {number} The value rounded to two decimal places
 */
export const roundOffValue = (val) => {
  console.warn('roundOffValue() is deprecated. Use decimal-utils.roundValue() instead.');
  return Math.round(toNumber(val) * 100) / 100;
};

/**
 * @deprecated Use decimal-utils.formatDecimal() instead
 * @param {number|string} val - The value to format
 * @returns {string} The value formatted to two decimal places
 */
export const formatTwoDecimals = (val) => {
  console.warn('formatTwoDecimals() is deprecated. Use decimal-utils.formatDecimal() instead.');
  const n = Number(val);
  if (isNaN(n)) return "0.00";
  return (Math.round(n * 100) / 100).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

/**
 * @deprecated Use decimal-utils.formatDecimal() with appropriate options
 * @param {number|string} val - The percentage value to format
 * @returns {string} The percentage formatted to two decimal places
 */
export const formatTwoDecimalsPercentage = (val) => {
  console.warn('formatTwoDecimalsPercentage() is deprecated. Use decimal-utils.formatDecimal() with appropriate options instead.');
  const n = Number(val);
  if (isNaN(n)) return "0.00";

  // Round to 2 decimal places using standard rounding
  const rounded = Math.round(n * 100) / 100;

  return rounded.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
